import type { ProductListItemInlineExternal } from 'types/capi/shared';

import ImpressionEvent, { type ImpressionType } from './ImpressionEvent';

const NO_PRICE = -1;

export type InlineProductCardImpressionProperties = {
  destination_url: string;
  module_position?: number;
  module_type: string;
  position: number;
  price_currency: string;
  price_regular: number;
  price_sale?: number;
  product_name?: string;
  retailer_id?: string;
};

type EventData = {
  guestId?: string;
  isBot: boolean;
  modulePosition?: number;
  moduleType: string;
  position: number;
  product: ProductListItemInlineExternal;
};

class InlineProductCardImpressionEvent extends ImpressionEvent<
  EventData,
  InlineProductCardImpressionProperties
> {
  protected get impressionType(): ImpressionType {
    return 'inline_product_card';
  }

  protected getImpressionProperties(): InlineProductCardImpressionProperties {
    const { modulePosition, moduleType, position, product } = this.data;

    return {
      destination_url: product.url,
      module_position: modulePosition,
      module_type: moduleType,
      position,
      price_currency: product.price.currency,
      price_regular: product.price.regular ?? NO_PRICE,
      price_sale: product.price.sale ?? undefined,
      product_name: product.name,
      retailer_id: product.affiliate?.canonical_id
    };
  }
}

export default InlineProductCardImpressionEvent;
